import {createApp} from 'vue'
import options from './MenuCountryPanel.options'
import { useMainStore } from 'stores/main.store'

const scrapeMenuForLinkData = function(MenuCountryPanelDOM) {
    const mainStore = useMainStore()

    const displayName = MenuCountryPanelDOM.querySelector('.be-menu-country-panel__left-dropdown-button-text').textContent.trim()
    const links = MenuCountryPanelDOM.querySelectorAll('.be-menu-country-panel__left-dropdown-overlay a') 

    const data = Array.from(links).reduce((allLinks, linkDOM) => {
        allLinks.push({
            href: linkDOM.href,
            displayName: linkDOM.querySelector('.be-menu-country-panel__left-dropdown-overlay-list-item-text').innerText.trim(),
            icon: linkDOM.querySelector('svg') ? linkDOM.querySelector('svg').outerHTML : null,
            iconAriaLabel: linkDOM.querySelector('.be-visually-hidden').innerText.trim(), 
        })
        return allLinks
    }, [])
    
    mainStore.setRegionMenuData({ 
        displayName: displayName, 
        links: data,
        order: 2,
    })
}

const el = '.be-component--menu-country-panel'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((MenuCountryPanelDOM)=>{
            const template = MenuCountryPanelDOM.innerHTML
            options.template = template
            const component = createApp(options).use(Store)
            scrapeMenuForLinkData(MenuCountryPanelDOM)
            component.mount(MenuCountryPanelDOM)
        })
    }
}

